/** @param {string} ymd */
export function addDaysToYmd(ymd, n) {
  const s = String(ymd || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const [y, m, d] = s.split('-').map(Number);
  const dt = new Date(y, m - 1, d + n);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
}

export function normalizeYmd(v) {
  if (v == null) return '';
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  if (s.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const t = Date.parse(s);
  if (!Number.isFinite(t)) return '';
  return new Date(t).toISOString().slice(0, 10);
}

/**
 * @param {string} raceYmd
 * @param {string[]} sortedWeekStarts ascending Monday keys YYYY-MM-DD
 */
export function raceToWeekBucket(raceYmd, sortedWeekStarts) {
  const r = String(raceYmd || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(r) || !sortedWeekStarts?.length) return null;
  const ws = [...sortedWeekStarts].sort();
  for (let i = 0; i < ws.length; i++) {
    const start = String(ws[i]).slice(0, 10);
    const next = ws[i + 1] != null ? String(ws[i + 1]).slice(0, 10) : null;
    if (r < start) return null;
    if (next == null || r < next) return ws[i];
  }
  return ws[ws.length - 1];
}

export function placeRacesForWeekOverview(races, domainDates, granularity) {
  if (!races?.length || !domainDates?.length) return [];
  const sorted = [...new Set(domainDates.map((d) => String(d).slice(0, 10)))].filter(Boolean).sort();
  const out = [];
  for (const race of races) {
    const r = normalizeYmd(race.date);
    if (!r) continue;
    let chartX = null;
    if (granularity === 'day') {
      chartX = sorted.includes(r) ? r : null;
    } else {
      chartX = raceToWeekBucket(r, sorted);
    }
    if (chartX != null) out.push({ ...race, chartX });
  }
  return out;
}

/** Map races to exact X category strings from chart data (threshold / KPI / etc.). */
export function placeRacesOnChartCategories(races, xCategories) {
  if (!races?.length || !xCategories?.length) return [];
  const cats = [...new Set(xCategories)].filter((c) => c != null && c !== '');
  const out = [];
  for (const race of races) {
    const r = normalizeYmd(race.date);
    if (!r) continue;
    const chartX = cats.find((c) => normalizeYmd(c) === r);
    if (chartX != null) out.push({ ...race, chartX });
  }
  return out;
}
